// extracted by mini-css-extract-plugin
export default {"tabContainer":"EmailVerificationRequired_tabContainer__NoIwM","buttonsContainer":"EmailVerificationRequired_buttonsContainer__5Ke35"};